export const CONTAINER_TYPES = {
  ISSUES: 'issue',
  LBS: 'lbs',
  REPORT: 'report',
  CHECKLIST: 'checklist'
};

export const SERVICE_TYPES = {
  FIELD_MANAGEMENT: 'fng'
};
